import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { SingleResponseModel } from '../../../../common/models/single-response.model';
import { FinancialIncomeActionTypes } from '../actions/financial-income.actions';
import { SummaryFinancialIncomeModel } from '../../models/summary-financial-income.model';
import { FinancialIncomeActions, LoadFinancialIncomesSuccess } from '../actions/financial-income.actions';

export interface FinancialIncomeState {
  items: SummaryFinancialIncomeModel[];
  total: number;
  res: PaginableResponseModel<SummaryFinancialIncomeModel>;
  selected: SingleResponseModel<SummaryFinancialIncomeModel> | null;
  loading: boolean;
  error: any
}


export const initalState: FinancialIncomeState = {
  items: [],
  total: 0,
  res: null,
  selected: null,
  loading: false,
  error: null
};

export function FinancialIncomeReducer(
  state = initalState,
  action: FinancialIncomeActions
): FinancialIncomeState {
  switch (action.type) {
    case FinancialIncomeActionTypes.LoadFinancialIncomes:
      return { ...state, loading: true, error: null };

    case FinancialIncomeActionTypes.LoadFinancialIncomesSuccess:
      const { items, total } = (action as LoadFinancialIncomesSuccess).payload;
      return {
        ...state,
        loading: false,
        error: null,
        items: items,
        total: total,
      };

    case FinancialIncomeActionTypes.LoadFinancialIncomesFailure:
     return { ...state, loading: false, error: action.payload.error };

     case FinancialIncomeActionTypes.LoadFinancialIncomeSuccess:
       return {
         ...state,
         selected: action.payload
       };

    default:
      return state;
  }
}
